export default __webpack_public_path__ + "static/media/img3.4d881768.svg";